import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  _setIsReferralDataLoaded,
  _setDateReferralSentFromSAP,
  _setDateofSAPOrJailRelease,
  _setCountyofParoleId,
  _setDrugTreatmentProgramTransitionCoordinatorId,
  _setDateReferralSenttoSAP,
  _setSTOPPlacementCoordinatorId,
  _setEpdIcnDateRelExp,
  _setSTOPResponse,
  _setClinicalInformationTreatmentRecommendations,
  _setEpdIrydsc,
} from '../../stopmodule/stopModuleAction';
import initialState from './updateReferralFormInitialState';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getReferralForm = createAsyncThunk(
  'stop/getReferralForm',
  async (params) => {
    const { referralTabUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(referralTabUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const referralSlice = createSlice({
  name: 'stop/referral',
  initialState,
  reducers: {
    setIsReferralDataLoaded: _setIsReferralDataLoaded,
    setDateReferralSentFromSAP: _setDateReferralSentFromSAP,
    setDateofSAPOrJailRelease: _setDateofSAPOrJailRelease,
    setCountyofParoleId: _setCountyofParoleId,
    setDrugTreatmentProgramTransitionCoordinatorId:
      _setDrugTreatmentProgramTransitionCoordinatorId,
    setDateReferralSenttoSAP: _setDateReferralSenttoSAP,
    setSTOPPlacementCoordinatorId: _setSTOPPlacementCoordinatorId,
    setEpdIcnDateRelExp: _setEpdIcnDateRelExp,
    setSTOPResponse: _setSTOPResponse,
    setClinicalInformationTreatmentRecommendations:
      _setClinicalInformationTreatmentRecommendations,
    setEpdIrydsc: _setEpdIrydsc,
  },
  extraReducers: {
    [getReferralForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setIsReferralDataLoaded,
  setDateReferralSentFromSAP,
  setDateofSAPOrJailRelease,
  setCountyofParoleId,
  setDrugTreatmentProgramTransitionCoordinatorId,
  setDateReferralSenttoSAP,
  setSTOPPlacementCoordinatorId,
  setEpdIcnDateRelExp,
  setSTOPResponse,
  setClinicalInformationTreatmentRecommendations,
  setEpdIrydsc,
} = referralSlice.actions;

export default referralSlice.reducer;
